<div class="card-header bg-success">
  <div class="row">
    <div class="col-md-6">
      <h3 class="text-white">
        Quote: {{ quoteDetails?.quote_ref_number || '—' }}
        <span class="badge ml-2" [ngClass]="statusBadgeClass" style="font-size: 0.55em; vertical-align: middle;">{{ statusLabel }}</span>
      </h3>
    </div>
    <div class="col-md-6 text-right">
      <span>
          <a [routerLink]="['/breakdown/quote', id]" class="btn btn-danger btn-sm">Edit</a>
      </span>
      <span>
          <button (click)="issueQuotePopup(issueQuoteModal)" class="btn btn-dark btn-sm ml-2">Convert to Policy and Issue Cover</button>
      </span>
    </div>
  </div>
</div>
<mat-tab-group class="float-left w-100" [(selectedIndex)]="selectedIndex">
  <mat-tab>
    <ng-template mat-tab-label>
      Overview
    </ng-template>
    <div class="card-body">
      <app-breakdown-overview [quoteDetails]="quoteDetails"></app-breakdown-overview>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      Full Details
    </ng-template>
    <div class="card-body">
      <app-breakdown-full-details [quoteDetails]="quoteDetails"></app-breakdown-full-details>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      Financials
    </ng-template>
    <div class="card-body">
      <app-breakdown-financials [quoteDetails]="quoteDetails"></app-breakdown-financials>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      Documents
    </ng-template>
    <div class="card-body">
      <app-breakdown-documents [quote]="quoteDetails"></app-breakdown-documents>
    </div>
  </mat-tab>
</mat-tab-group>
<ng-template #issueQuoteModal let-modal>
  <div class="modal-body">
    <div *ngIf="disablIfPastDate" class="alert alert-danger">
      The inception date is in the past and needs to be updated. Please edit the quote and update the inception date before placing on cover.
    </div>
    <p *ngIf="!disablIfPastDate">Do you want to issue the quote?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-sm" (click)="modal.close()">{{ disablIfPastDate ? 'Close' : 'No' }}</button>
    <button *ngIf="!disablIfPastDate" type="button" class="btn btn-success btn-sm" (click)="issueQuote()">Yes</button>
  </div>
</ng-template>
